import { ProdVariables } from './ProdVariables';
import { TestVariables } from './TestVariables';

// Use TestVariables when REACT_APP_USE_TEST_VARIABLES is set to 'true'
const useTestVariables = process.env.REACT_APP_USE_TEST_VARIABLES === 'true';

export const config = useTestVariables ? TestVariables : ProdVariables;
